import { Injectable } from '@angular/core';

export type SettingsConfirmModalVariant = 'danger' | 'primary';

/**
 * Config for `SettingsConfirmModalService.confirm()`. Deliberately generic — LUNA-28 needs this
 * for title deletion, but the button color/copy are config-driven (not hardcoded to "Delete") so
 * a future confirm flow (e.g. Clone) can reuse the same modal with a different `confirmVariant`.
 * Kept as its own `@Injectable` class (not just an interface) so it can be supplied as a DI value
 * token the same way `SettingsSidePanelOptions` is for the side panel.
 */
@Injectable({
  providedIn: 'root',
})
export class SettingsConfirmModalOptions {
  id?: number | string;
  title = '';
  message = '';
  confirmText = 'Confirm';
  cancelText = 'Cancel';
  confirmVariant: SettingsConfirmModalVariant = 'danger';
  onConfirm?: () => void;
  onCancel?: () => void;
}

export const SettingsConfirmModalDefaults: Partial<SettingsConfirmModalOptions> = {
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  confirmVariant: 'danger',
};
